<template>
  <vx-card>
    <div class="vx-row" id="loader2">
      <div class="vx-col flex-1" id="account-info-col-1">
        <template v-for="(fName, fId) in getCurrentDataStructureInChunkForView[0]">
          <vs-row :key="fId" class="p-2">
            <vs-col class="font-semib old" vs-type="flex" vs-w="6">{{
              fName[1].label
            }}</vs-col>

            <vs-col v-if="fName[1].type == 'aronSelect'" vs-type="flex" vs-w="5">:
              {{
                decodeSelectValue(getMainInfo[fName[0]], fName[1].data)
              }}</vs-col>

            <vs-col v-else-if="fName[1].type == 'aronMultiSelect'" vs-type="flex" vs-w="5">: {{
              decodeMultiSelectValue(getMainInfo[fName[0]]) }}</vs-col>

            <vs-col v-else-if="fName[1].type == 'aronCurrency'" vs-type="flex" vs-w="5">:
              {{
                formatCurrency(fName[1].currency, getMainInfo[fName[0]])
              }}</vs-col>
            <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6">
              <img :src="showFileOrImageHandler(getMainInfo[fName[0]])" />
            </vs-col>

            <vs-col v-else vs-type="flex" vs-w="6">: {{ getMainInfo[fName[0]] }}</vs-col>
          </vs-row>
        </template>
      </div>

      <div class="vx-col flex-1" id="account-info-col-2">
        <template v-for="(fName, fId) in getCurrentDataStructureInChunkForView[1]">
          <vs-row :key="fId" class="p-2">
            <vs-col class="font-semibold" vs-type="flex" vs-w="7">{{
              fName[1].label
            }}</vs-col>

            <vs-col v-if="fName[1].type == 'aronSelect'" vs-type="flex" vs-w="5">:
              {{
                decodeSelectValue(getMainInfo[fName[0]], fName[1].data)
              }}</vs-col>

            <vs-col v-else-if="fName[1].type == 'aronMultiSelect'" vs-type="flex" vs-w="5">: {{
              decodeMultiSelectValue(getMainInfo[fName[0]]) }}</vs-col>

            <vs-col v-else-if="fName[1].type == 'aronCurrency'" vs-type="flex" vs-w="5">:
              {{
                formatCurrency(fName[1].currency, getMainInfo[fName[0]])
              }}</vs-col>

            <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6">
              <img :src="showFileOrImageHandler(getMainInfo[fName[0]])" />
            </vs-col>

            <vs-col v-else vs-type="flex" vs-w="5">: {{ getMainInfo[fName[0]] }}</vs-col>
          </vs-row>
        </template>
      </div>
    </div> 
    <vs-row class="text-xl p-2 pt-20" vs-type="flex" vs-justify="center" v-if="getUserInfo.role != 'Viewer' &&getUserInfo.role != 'Petron Client' && getUserInfo.role != 'Viewer, MTBE 2023 Client' && getUserInfo.role != 'PDH SHUTDOWN 2024' && getUserInfo.role != 'MTBE 2023 Client' && getUserInfo.role != 'Client' && getUserInfo.role != 'SMDS Client' && (getProjectSelected.projectType == '1' || getProjectSelected.projectType == '3' || getProjectSelected.projectType == '4' || getProjectSelected.projectType == '5' || getProjectSelected.projectType == '6')
      ">

      <vs-col class="p-10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button @click="updateStatus('5')" color="gray" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">No Status
        </vs-button>
        <vs-button @click="updateStatus('1')" color="primary" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">Break</vs-button>
        <vs-button @click="updateStatus('2')" color="danger" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">Defect</vs-button>
        <vs-button @click="updateStatus('3')" color="yellow" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">Box-up</vs-button>
        <vs-button @click="updateStatus('4')" color="success" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">Complete</vs-button>
      </vs-col>
    </vs-row>
    <vs-row class="text-xl p-2" vs-type="flex" vs-justify="center" v-if="getUserInfo.role != 'Client' && (getProjectSelected.projectType == '1' || getProjectSelected.projectType == '3')
      ">
      <vs-col class="p-10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <div>
          <span class="text-LG">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT JOINT TYPE
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <br />
          <v-select v-model="selectedJointType" :options="getOrigCurrentDataStructure.jointType.data" />
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="text-xl p-2 pt-20" vs-type="flex" vs-justify="center">
      <vs-col class="p-10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button @click="cancel()" color="warning" size="large">Close</vs-button>
      </vs-col>
    </vs-row>

    <vs-prompt title="Reject Record" @cancel="val = ''" @accept="validateRejectRecord" :active.sync="showRejectReason">
      <div class="con-exemple-prompt">
        <span>Why are you rejecting this record?</span>
        <vs-input v-validate="'required|min:3'" placeholder="enter here..." vs-placeholder="enter here..."
          v-model="reasonModel" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import { helperMixin } from "../../mixin/helperMixin";
import { dialogMixin } from "../../mixin/dialogMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { alertMixin } from "../../mixin/alertMixin";

import axios from "@/axios.js";
export default {
  mixins: [helperMixin, dialogMixin, axiosMixin, alertMixin],
  components: {
    vSelect,
  },
  data() {
    return {
      reasonModel: "",
      showRejectReason: false,
      showAlert: false,
      showRejectReason: false,
      rejectReasonMessage: "",
      reasonModel: "",
      payLoad: {},
      endPoint: "",
      rejectDialogTitle: "",
      successMessage: "",
      sucessEventName: "",
      successEventValue: "",
      selectedJointType: "",
    };
  },

  computed: {
    ...mapGetters({
      getCurrentDataStructureInChunkForView:
        "profile/getCurrentDataStructureInChunkForView",
      getOrigCurrentDataStructure: "profile/getOrigCurrentDataStructure",
      getMainInfo: "profile/getCurrentMainInfo",
      getUserInfo: "auth/getUserInfo",
      getProjectSelected: "auth/getProjectSelected",
    }),

    // this.selectedJointType = this.getMainInfo
    settings() {
      this.showAlert = true; //we need to trigger this so that the alert will show

      return this.getMainInfoSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    },
    baseURl() {
      return axios.defaults.baseURL;
    },
  },
  created() { },
  mounted() {
    console.log("getUserInfo:::", this.getUserInfo);
    this.selectedJointType = {
      id: this.getMainInfo.jointType,
      label: this.getMainInfo.jointType,
    };

    this.$watch("selectedJointType", (value) => {
      console.log("selected:", this.selectedJointType);
      this.startLoading("loader2");
      let jointType = 8;//no joint type
      if (this.selectedJointType != null) {
        jointType = this.selectedJointType.id
      }
      this.aronPost(
        "updateJointType",
        { id: this.getMainInfo.id, val: jointType },
        "",
        ""
      )
        .then((response) => {
          this.closeLoading("loader2");
          if (response.data.code == 200) {
            this.successAlert("Success", "Joint Type has been updated");
            this.$emit("result", "list");
          } else {
            this.errorAlert("Warning", response.data.error);
          }

          this.closeLoading("loader2");
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading("loader2");
        });
    });
  },

  methods: {
    startLoading() {
      this.$vs.loading({
        container: "#loader2",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader2 > .con-vs-loading");
    },
    updateStatus(status) {
      this.startLoading("loader2");
      this.aronPost(
        "updateStatus",
        { status: status, id: this.getMainInfo.id },
        "",
        ""
      )
        .then((response) => {
          this.closeLoading("loader2");
          if (response.data.code == 200) {
            this.successAlert("Success", "Join has been updated");
            this.$emit("result", "list");
          } else {
            this.errorAlert("Warning", response.data.error);
          }

          this.closeLoading("loader2");
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading("loader2");
        });
    },
    validateRejectRecord() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.showRejectReason = false;
        this.rejectTheRecordNow();
      }
    },
    cancel() {
      this.$emit("result", "test");
    },
    approveNow() {
      this.confirmAlert(
        "Approve Record",
        "Are you sure you want to Approve this record?"
      ).then((val) => {
        this.aronPost(
          "approvedRecord",
          { agencyRecordID: this.getMainInfo.id },
          "",
          ""
        )
          .then((response) => {
            if (response.data.code == 200) {
              this.successAlert("Success", "Rekod telah berjaya disimpan");
              this.$emit("result", "list");
            } else {
              this.errorAlert("Warning", response.data.error);
            }

            this.stopLoading("loader");
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
            this.stopLoading("loader");
          });
      });
    },
    rejectRecord() {
      this.showRejectReason = true;
    },
    rejectTheRecordNow() {
      var thisOrig = this;
      this.aronPost(
        "rejectRecord",
        { agencyRecordID: this.getMainInfo.id, reason: this.reasonModel },
        "",
        ""
      )
        .then((response) => {
          if (response.data.code == 200) {
            this.successAlert("Success", "Rekod telah berjaya disimpan");
            this.$emit("result", "list");
          } else {
            this.errorAlert("Warning", response.data.error);
          }
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
        });
    },
    handleEmitEvent(eventName, eventValue) {
      this.$emit(eventName, { eventName: eventName, eventValue: eventValue });
    },
    handleSubmit(
      endPoint,
      title,
      message,
      payLoad,
      getReason,
      rejectReasonMessage,
      rejectDialogTitle,
      successMessage,
      sucessEventName,
      successEventValue
    ) {
      this.payLoad = payLoad;
      this.endPoint = endPoint;
      this.successMessage = successMessage;
      if (getReason) {
        this.showRejectReason = true;
        this.rejectReasonMessage = rejectReasonMessage;
        this.rejectDialogTitle = rejectDialogTitle;
      } else {
        this.confirmAlert(title, message).then((res) => {
          this.submitNow();
        });
      }
    },
    validateReason() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.addToObject(this.payLoad, { rejectReason: this.reasonModel });
        this.submitNow();
      }
    },
    submitNow() {
      this.aronPost(this.endPoint, this.payLoad, "", "")
        .then((response) => {
          if (response.data.status == "success") {
            this.normarAlert("Success", this.successMessage).then((res) => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue,
              });
            });
          } else {
            this.normarAlert(
              "Error",
              "Something Went wrong please try again later"
            ).then((res) => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue,
              });
            });
          }

          //go back
        })
        .catch((error) => {
          console.error("error ActionContainer reason:", error);
        });
    },
    showFileOrImageHandler(source) {
      var filename = this.getFileExtention(source);
      if (filename == "pdf") {
        this.showPdf = true;
        this.thePdfSource = this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        this.showImage = true;
        return this.baseURl + "/storage/" + source;
      }
    },
    editData() { },
    formatCurrency(currency, value) {
      return this.displayCurrency(currency, value);
    },
    decodeSelectValue(value, options) {
      return this.decodeValueForSelect(options, value);
    },
    decodeMultiSelectValue(value) {
      return this.flattenJsonStringArray(value, "label");
    },
  },
};
</script>

